import axioPath from "api/axioPath";
import { UPDATE_DATA } from "redux/actions/action_types";

export const createOrder = (data, token) => (dispatch) => {
  return axioPath.post("/pickup/create_pickup_order", data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  }).then((response) => {
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return { error: false, data: response.data };
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const fetchEditOrderApi = (ordRefNo, token) => (dispatch) => {
  return axioPath.get(`/pickup/order/${ordRefNo}`, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  }).then((response) => {
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return { error: false, data: response.data };
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const updateOrder = (data, token) => (dispatch) => {
  return axioPath.post("/pickup/update", data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  }).then((response) => {
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return { error: false, data: response.data };
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};

export const deleteOrder = (data, token) => (dispatch) => {
  return axioPath.post(`/pickup/delete`, data, {
    headers: {
      Authorization: `${token}`,
      UserType: "external",
    },
  }).then((response) => {
    dispatch({ type: UPDATE_DATA, payload: response.data });
    return { error: false, data: response.data };
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data };
    else return ex;
  });
};